// @flow
import MyCompany from './MyCompanyLoader'
export default MyCompany
